module.exports = __webpack_public_path__ + "img/shouru.f643d204.png";